module.exports = __webpack_public_path__ + "static/media/amsterdam.c6adf50b.png";